import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getEcommerceHowWeDev(tenant: Tenant): InfoCardProps[] {
	return [
		{
			desc: "Na úvod sp[[zhodnotíme vaši situaci, potřeby]] a zjistíme, v jakém stádiu podnikání se  nacházíte a jaké jsou vaše cíle. Podle toho vám doporučíme ideální e-commerce řešení.",
		},
		{
			desc: "sp[[Pustíme se do vývoje]] e-commerce řešení na míru. Sázíme na tzv. agilní vývoj, díky kterému projekt rozdělíme na menší fáze.",
		},
		{
			desc: "Po dokončení vývoje a dalších prací s vámi doladíme detaily a sp[[spustíme tzv. MVP]] (Minimum viable product – produkt, který splňuje primární cíle, je spustitelný a životaschopný). Na základě MVP můžeme e-shop dále rozvíjet.",
		},
		{
			desc: "Po spuštění vám sp[[budeme k ruce s podporou]] i dalším rozvojem e-shopu.",
		},
	];
}
